import React from 'react';
import { Link } from 'react-router-dom';
import { posts } from '../data/posts';
import Card from '../components/Card/Card.js';
import './Home.css';
import Hero from '../components/Herosection/Hero.js';

const Home = () => {
  return (
    <>
     <Hero/>

     <section className="projects-section">
      <div className="projects-section__header">
        <h2 className="projects-section__title">
          <span className="projects-section__star">✳</span>
          Selected Projects
        </h2>

        <Link to="/projects" className="projects-section__viewAll">
          <span>View all projects</span>
          <span className="projects-section__arrow">→</span>
        </Link>
      </div>

      <div className="post-container">
        {posts.map((post, index) => (
          <Card
            key={index}
            image={post.image}
            name={post.name}
            category={post.category || post.subtitle || 'Explainer Animation'}
            url={`/post/${index + 1}`}
         />
        ))}
      </div>
    </section>
    </>
   
  );
};

export default Home;
